import React, { FC } from 'react';
import {
  Container,
  ContainerCollapse,
  Toggle
} from '../../../../../procedures/modules/scholarships/bse/components/Collapsible/styled';
import CourseTitle from './CourseTitle';

interface IProps {
  color: string;
  setShow: any;
  show: boolean;
  alwaysOpen?: boolean;
  title: string;
  styleTitle?: React.CSSProperties;
  catalogNumber: string;
  courseStatus: string;
  finalGrade?: string;
}

const Collapsible: FC<IProps> = ({
  color,
  children,
  setShow,
  show,
  alwaysOpen = false,
  title,
  styleTitle,
  catalogNumber,
  courseStatus,
  finalGrade
}) => {
  const colorLine = alwaysOpen ? '' : color;
  const toggleHeight = () => {
    if (title.length >= 75) return '100px';
    if (title.length >= 29) return '80px';
    return '60px';
  };

  return (
    <Container>
      <Toggle
        onClick={() => {
          setShow(!show);
        }}
        color={colorLine}
        height={toggleHeight()}
        className={show ? 'toggleOpen' : ''}
        alwaysOpen={alwaysOpen}
        data-testid="cpm-course-toggle"
      >
        <CourseTitle
          title={title}
          styleTitle={styleTitle}
          catalogNumber={catalogNumber}
          subtitle={courseStatus}
          finalGrade={finalGrade}
          show={show}
        />
      </Toggle>
      <ContainerCollapse color={colorLine}>
        <div className={`toggle-content ${show ? 'expanded' : ''}`}>
          <div style={{ margin: '20px 24px 24px 28px' }}>{children}</div>
        </div>
        {/* {(show || alwaysOpen) && (
          <ChildrenContainer style={styleChildren}>
            <Collapse isOpen={show}>{children}</Collapse>
          </ChildrenContainer>
        )} */}
      </ContainerCollapse>
    </Container>
  );
};

export default Collapsible;
